module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Michael Boris","short_name":"Michael Boris","display":"standalone","start_url":"/","background_color":"#ffffff","theme_color":"#243B55","icon":"src/images/michaelboris-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"52ccdad0c4c2dd54180196cb43463ae3"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
